export const BOARD_NAVIGATE_TO_CONTACT_MESSAGE_TYPE = "board:navigate-to-contact"

export const INBOX_OPEN_CHAT_BY_PHONE_EVENT = "inbox:open-chat-by-phone"

export const INBOX_OPEN_WABA_TEMPLATE_SELECTOR_EVENT = "inbox:open-waba-template-selector"
